import { render, staticRenderFns } from "./deviceMRI.vue?vue&type=template&id=5e77635a&scoped=true"
import script from "./deviceMRI.vue?vue&type=script&lang=js"
export * from "./deviceMRI.vue?vue&type=script&lang=js"
import style0 from "./deviceMRI.vue?vue&type=style&index=0&id=5e77635a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77635a",
  null
  
)

export default component.exports